const MOBILE_USER_AGENT_PATTERN =
  /Mobi|Android|iPhone|iPod|iPad|IEMobile|Windows Phone|BlackBerry|BB10|webOS|Opera Mini|Tablet|PlayBook|Silk|Kindle/i;

export interface DeviceSignals {
  userAgent: string;
  userAgentDataMobile?: boolean;
  maxTouchPoints: number;
  screenWidth: number;
  screenHeight: number;
}

export function isMobileDevice({
  userAgent,
  userAgentDataMobile,
  maxTouchPoints,
  screenWidth,
  screenHeight,
}: DeviceSignals): boolean {
  if (userAgentDataMobile === true || MOBILE_USER_AGENT_PATTERN.test(userAgent)) {
    return true;
  }

  // iPadOS can present a macOS user agent when "Request Desktop Site" is enabled.
  if (/Macintosh/i.test(userAgent) && maxTouchPoints > 1) {
    return true;
  }

  // Keep catching phone-sized touch devices if desktop mode masks the user
  // agent. Touch support alone must not block touchscreen or foldable laptops.
  const shortestScreenSide = Math.min(screenWidth, screenHeight);
  return maxTouchPoints > 0 && shortestScreenSide <= 600;
}

export function isMobileBrowser(): boolean {
  const navigatorWithUserAgentData = navigator as Navigator & {
    userAgentData?: { mobile?: boolean };
  };

  return isMobileDevice({
    userAgent: navigator.userAgent,
    userAgentDataMobile: navigatorWithUserAgentData.userAgentData?.mobile,
    maxTouchPoints: navigator.maxTouchPoints,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
  });
}
